// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/polyfill/node_modules/core-js/modules/_to-object.js
// module id = 26
// module chunks = 0